module.exports = __webpack_public_path__ + "img/belgium-stomach-cancer-male.2290ab1a.png";